export enum Granularity {
  month = "month",
}
